import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements OnInit {
  @Input() appAutofocus: boolean = false;

  constructor(private el: ElementRef) {
    if (!el.nativeElement.focus) {
      throw new Error('Element does not accept focus.');
    }
  }

  ngOnInit(): void {
    if (this.appAutofocus) {
      const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
      input.focus();
    }
  }
}
